<template>
  <div class="app-container">
    <Layout><template #left>
        <div class="aside">
          <siteaside />
        </div>
      </template>
      <template #default>
        <RouterView />
      </template>
    </Layout>
    <TopTop/>
  </div>
</template>

<script>
import Layout from "./components/Layout.vue";
import siteaside from "./components/siteaside.vue";
import TopTop from "./components/TopTop.vue";
export default {
  components: {
    Layout,
    siteaside,
    TopTop,
  },

};
</script>

<style scoped lang="less">
@import "./style/mixin.less";

.app-container {
  .self-fill(fixed);
}
.aside{
  width: 250px;
  height: 100%;
}
</style>